import { PageTypes } from '#shared/resolve-page';

// Category IDs - exported for use in other components
export const CATEGORY_IDS = {
    men: {
        shop: '0192fc2664b67d73af1a60c80e600c9c',
        main: 'c81e728d9d4c2f636f067f89cc14862c',
        sale: '0192fc26c99c796ca67521708f76768c',
        new: '0192fc26917e79b29e6e2c1b822352d7',
    },
    women: {
        shop: '0192e206b0c27153b6c3697ec6e21c44',
        main: 'c4ca4238a0b923820dcc509a6f75849b',
        sale: '0192e206d73d7fbaab6f5561b4be5cd9',
        new: '0192e206c77a7dbb9e16974d062f97aa',
    },
};

// Root/Home category ID - the backend returns this as tweakwiseId for manufacturer
// sale/new pages that don't have a specific category mapping.
export const ROOT_CATEGORY_ID = '018f1a68081f71168e26781259f9cf0a';

export async function useGetCategoryTree() {
    const config = useRuntimeConfig();
    const { $tweakwise } = useNuxtApp();
    const route = useRoute();
    const pageDataStore = usePageDataStore();

    // Constants
    const instanceKey = config.public.tweakwise.instanceKey;
    const profileKey = $tweakwise?.getVisitorId() ?? '';

    interface PageData {
        type?: string;
        context?: string;
        id?: string;
        parentId?: string;
        variant?: string;
        tweakwiseId?: string;
        manufacturer?: any;
    }

    const pageData = pageDataStore.data as PageData | null;
    const isSalePage = route.path.includes('/sale');
    const isNewPage = route.path.includes('/nieuw');
    const categoryTreeCid = ref('');

    // Skip for product manufacturer pages
    if (pageData?.type !== PageTypes.ManufacturerDetail && pageData?.type !== PageTypes.ManufacturerCategory) {
        buildCategoryTree();
    }

    function buildCategoryTree() {
        // For sale pages
        if (isSalePage) {
            if (pageData?.context === 'men') {
                setCategoryForSaleOrNew(CATEGORY_IDS.men.sale);
            } else if (pageData?.context === 'ladies') {
                setCategoryForSaleOrNew(CATEGORY_IDS.women.sale);
            }
        } else if (isNewPage) {
            if (pageData?.context === 'men') {
                setCategoryForSaleOrNew(CATEGORY_IDS.men.new);
            } else if (pageData?.context === 'ladies') {
                setCategoryForSaleOrNew(CATEGORY_IDS.women.new);
            }
        } else {
            if (pageData?.context === 'men' && pageData?.id !== CATEGORY_IDS.men.shop) {
                setCategoryForRegular(CATEGORY_IDS.men.main);
            } else if (pageData?.context === 'ladies' && pageData?.id !== CATEGORY_IDS.women.shop) {
                setCategoryForRegular(CATEGORY_IDS.women.main);
            } else if (pageData?.id === CATEGORY_IDS.women.shop) {
                categoryTreeCid.value = `&tn_cid=${CATEGORY_IDS.women.main}`;
            } else if (pageData?.id === CATEGORY_IDS.men.shop) {
                categoryTreeCid.value = `&tn_cid=${CATEGORY_IDS.men.main}`;
            }
        }
    }

    function setCategoryForSaleOrNew(categoryId: string) {
        const { id, parentId } = pageData || {};

        if (!id || id === categoryId) {
            categoryTreeCid.value = `&tn_cid=${categoryId}`;
            return;
        }

        if (parentId && parentId !== categoryId) {
            categoryTreeCid.value = `&tn_cid=${categoryId}-${parentId}-${id}`;
        } else {
            categoryTreeCid.value = `&tn_cid=${categoryId}-${id}`;
        }
    }

    function setCategoryForRegular(mainId: string) {
        const { id, parentId } = pageData || {};

        if (!id) return;

        if (parentId && parentId !== mainId) {
            categoryTreeCid.value = `&tn_cid=${mainId}-${parentId}-${id}`;
        } else {
            categoryTreeCid.value = `&tn_cid=${mainId}-${id}`;
        }
    }

    const response = await fetch(
        'https://gateway.tweakwisenavigator.com/navigation/' +
            instanceKey +
            '?format=json&tn_ps=48' +
            '&tn_profile=' +
            profileKey +
            categoryTreeCid.value +
            '&tn_parameters_except=ae-sw-op-voorraad%3D1%26ae-season-archived=true',
    );
    const data = await response.json();

    return data.facets;
}
